export const CHECK_DEPOSIT_STEPS = {
  EDUCATION: 'EDUCATION',
  OVERVIEW: 'OVERVIEW',
  SUBMISSION: 'SUBMISSION',
  CUSTOMER_CONFIRMATION_REASONS: 'CUSTOMER_CONFIRMATION_REASONS'
};
